/**
 * NESSUNSE CARRELLO A DESTRA v10
 * SOLO dentro cart-notification (il drawer).
 * FIX: forza stile anche sul contenitore img per evitare icone sparse su mobile.
 * Piani: 65px | Extras: 65px con padding 14px (centrati)
 */
(function() {
  'use strict';

  if (window.__NessunSECarrello10__) return;
  window.__NessunSECarrello10__ = true;

  var PLUS = 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/Screenshot_2026-03-04_alle_10.13.37.png?v=1772615644';

  var RULES = [
    { text: 'nessunse me',       icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/scudo-2.svg?v=1772528698', extra: false },
    { text: 'nessunse family',   icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/scudo-1.svg?v=1772116955', extra: false },
    { text: 'nessunse driver',   icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/scudo-4.svg?v=1772463693', extra: false },
    { text: 'nessunse job',      icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/scudo-5.svg?v=1772534055', extra: false },
    { text: 'nessunse business', icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/scudo-6.svg?v=1772122938', extra: false },
    { text: 'nessunse animal',   icon: 'https://cdn.shopify.com/s/files/1/0923/6106/4714/files/animal_1.svg?v=1770897073', extra: false },
    { text: 'rc capofamiglia',   icon: PLUS, extra: true },
    { text: 'capofamiglia',      icon: PLUS, extra: true },
    { text: 'soccorso stradale', icon: PLUS, extra: true },
    { text: 'soccorso',          icon: PLUS, extra: true },
    { text: 'tutela diritto',    icon: PLUS, extra: true },
    { text: 'tutela lavoro',     icon: PLUS, extra: true },
    { text: 'tutela circolazione', icon: PLUS, extra: true },
    { text: 'circolazione stradale', icon: PLUS, extra: true },
    { text: 'opzione animal',    icon: PLUS, extra: true }
  ];

  function isOurs(src) {
    if (!src) return false;
    return src.indexOf('scudo-') !== -1 ||
           src.indexOf('Screenshot_2026') !== -1 ||
           src.indexOf('animal_1.svg') !== -1;
  }

  function matchRule(text) {
    for (var i = 0; i < RULES.length; i++) {
      if (text.indexOf(RULES[i].text) !== -1) return RULES[i];
    }
    return null;
  }

  function getDrawer() {
    return document.querySelector('cart-notification') ||
           document.getElementById('minicart_wrapper');
  }

  /* Inject CSS once to fix container sizing globally inside the drawer */
  function injectStyles() {
    if (document.getElementById('nse-cart-icon-fix')) return;
    var style = document.createElement('style');
    style.id = 'nse-cart-icon-fix';
    style.textContent = [
      /* Force the img container (usually a div or a tag wrapping the product image) */
      'cart-notification [data-nse10-wrap] {',
      '  width: 65px !important;',
      '  min-width: 65px !important;',
      '  max-width: 65px !important;',
      '  height: 65px !important;',
      '  min-height: 65px !important;',
      '  max-height: 65px !important;',
      '  overflow: hidden !important;',
      '  flex-shrink: 0 !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  padding: 0 !important;',
      '  margin: 0 !important;',
      '  border-radius: 0 !important;',
      '  background: none !important;',
      '  aspect-ratio: auto !important;',
      '}',
      '',
      /* Also handle the case where the img is inside an <a> inside a <div> */
      'cart-notification [data-nse10-wrap] a {',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  width: 100% !important;',
      '  height: 100% !important;',
      '}',
      '',
      'cart-notification img[data-nse10] {',
      '  width: 65px !important;',
      '  height: 65px !important;',
      '  max-width: 65px !important;',
      '  max-height: 65px !important;',
      '  min-width: 65px !important;',
      '  min-height: 65px !important;',
      '  object-fit: contain !important;',
      '  border-radius: 0 !important;',
      '  background: none !important;',
      '  aspect-ratio: auto !important;',
      '}',
      '',
      'cart-notification img[data-nse10][data-nse10-extra="1"] {',
      '  padding: 14px !important;',
      '  box-sizing: border-box !important;',
      '}',
      '',
      'cart-notification img[data-nse10][data-nse10-extra="0"] {',
      '  padding: 0 !important;',
      '}',
      '',
      /* Kill any lazy-load placeholder or padding-bottom trick on the wrapper */
      'cart-notification [data-nse10-wrap]::before,',
      'cart-notification [data-nse10-wrap]::after {',
      '  display: none !important;',
      '  content: none !important;',
      '}',
      '',
      /* Also target #minicart_wrapper if that's the drawer */
      '#minicart_wrapper [data-nse10-wrap] {',
      '  width: 65px !important;',
      '  min-width: 65px !important;',
      '  max-width: 65px !important;',
      '  height: 65px !important;',
      '  min-height: 65px !important;',
      '  max-height: 65px !important;',
      '  overflow: hidden !important;',
      '  flex-shrink: 0 !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  padding: 0 !important;',
      '  margin: 0 !important;',
      '  border-radius: 0 !important;',
      '  background: none !important;',
      '  aspect-ratio: auto !important;',
      '}',
      '#minicart_wrapper img[data-nse10] {',
      '  width: 65px !important;',
      '  height: 65px !important;',
      '  max-width: 65px !important;',
      '  max-height: 65px !important;',
      '  min-width: 65px !important;',
      '  min-height: 65px !important;',
      '  object-fit: contain !important;',
      '  border-radius: 0 !important;',
      '  background: none !important;',
      '  aspect-ratio: auto !important;',
      '}',
      '#minicart_wrapper img[data-nse10][data-nse10-extra="1"] {',
      '  padding: 14px !important;',
      '  box-sizing: border-box !important;',
      '}',
      '#minicart_wrapper img[data-nse10][data-nse10-extra="0"] {',
      '  padding: 0 !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function process() {
    var drawer = getDrawer();
    if (!drawer) return;

    var imgs = drawer.getElementsByTagName('img');

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (isOurs(img.src)) continue;
      if (img.getAttribute('data-nse10') !== null) continue;

      var el = img.parentElement;
      var rule = null;
      var depth = 0;

      while (el && el !== drawer && depth < 5 && !rule) {
        var txt = (el.textContent || '').toLowerCase();
        if (txt.indexOf('€') !== -1 || txt.indexOf('eur') !== -1) {
          rule = matchRule(txt);
        }
        el = el.parentElement;
        depth++;
      }

      if (rule) {
        /* Replace image src */
        img.src = rule.icon;
        if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
        img.setAttribute('data-nse10', '');
        img.setAttribute('data-nse10-extra', rule.extra ? '1' : '0');

        /* Fix the immediate wrapper of the image (the container div or a tag) */
        var wrap = img.parentElement;
        if (wrap && wrap !== drawer) {
          wrap.setAttribute('data-nse10-wrap', '');
          /* Also remove any padding-bottom aspect-ratio hack */
          wrap.style.paddingBottom = '0';
          wrap.style.paddingTop = '0';
          wrap.style.height = '65px';

          /* If there's a grandparent that's also a tight image wrapper, fix it too */
          var grandWrap = wrap.parentElement;
          if (grandWrap && grandWrap !== drawer &&
              grandWrap.children.length === 1 &&
              grandWrap.tagName !== 'LI' &&
              grandWrap.tagName !== 'TR') {
            grandWrap.setAttribute('data-nse10-wrap', '');
            grandWrap.style.paddingBottom = '0';
            grandWrap.style.paddingTop = '0';
            grandWrap.style.height = '65px';
          }
        }
      }
    }
  }

  function init() {
    injectStyles();
    process();
    setInterval(process, 1000);

    if (document.body) {
      try {
        new MutationObserver(function() {
          setTimeout(process, 200);
          setTimeout(process, 600);
        }).observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    }

    console.log('[NSE] Carrello a destra v10 attivo');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
